export default __webpack_public_path__ + "static/media/grafik-helfen-sie-mit_en.3247d5f2.svg";